import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-outfit font-800 text-black mb-8">
          Privacy Policy
        </h1>
        
        <div className="w-24 h-1 bg-crimson mb-12"></div>

        <div className="space-y-8 text-gray-700 font-outfit font-600">
          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed mb-4">
              We collect information that you provide directly to us when registering for AI Day events:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Personal identification information (name, email, phone number)</li>
              <li>Professional information (organization, job title)</li>
              <li>Event preferences and interests</li>
              <li>Payment information for paid events</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">2. How We Use Your Information</h2>
            <p className="leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Process event registrations and manage attendance</li>
              <li>Communicate event details and updates</li>
              <li>Improve our events and services</li>
              <li>Send newsletters and promotional materials (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">3. Information Sharing</h2>
            <p className="leading-relaxed">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
              <li>Event partners and sponsors (with your consent)</li>
              <li>Service providers who assist in event operations</li>
              <li>Law enforcement when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">4. Data Security</h2>
            <p className="leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal information. However, no method 
              of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">5. Your Rights</h2>
            <p className="leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
              <li>Object to processing of your information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">6. Cookies and Tracking</h2>
            <p className="leading-relaxed">
              Our website uses cookies to enhance user experience, analyze site usage, and assist in our marketing efforts. 
              You can control cookie preferences through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">7. Children's Privacy</h2>
            <p className="leading-relaxed">
              AI Day events are not intended for individuals under the age of 18. We do not knowingly collect information from children.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">8. Changes to This Policy</h2>
            <p className="leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page 
              with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">9. Contact Us</h2>
            <p className="leading-relaxed">
              If you have questions about this Privacy Policy or our data practices, please contact us through the official AI Anytime channels.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-800">
            <p className="text-sm text-gray-500">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
